import { Box, Card, Typography } from "@mui/material";
import React from "react";
export function JewelledMoutzentra() {
  return (
    <Card sx={{ backgroundColor: "#bbbbbb" }}>
      <Typography variant="h1">Jewelled Moutzentra</Typography>

      <Typography>
        <Typography variant="h3">Ingredients</Typography>
        250g dried green or brown lentils <br></br>
        130g long grain rice <br></br>4 onions<br></br>3 garlic cloves<br></br>4
        tbsp olive oil<br></br>1 tsp cumin seeds<br></br>
        1/2 pomegranate<br></br>1 bunch flat leaf parsley<br></br>
        50g toasted flaked almonds<br></br>
        50g dried sour cherries <br></br>
        1/2 lemon <br></br>
      </Typography>

      <Typography>
        Place a large pan of salted water on to boil. <br></br>
        Thoroughly rinse the lentils in a sieve, picking out any stones, and
        then cook in the boiling water for 20 minutes until almost cooked.{" "}
        <br></br>
        <br></br>
        Meanwhile, rinse the rice in a sieve, then add to the pan for a further
        12 minutes, until perfectly cooked.<br></br>
        Drain the rice and lentils in a sieve or fine colander, and return to
        the hot pan to steam dry and keep fluffy.<br></br>
        <br></br>
        While the lentils are cooking, peel and finely slice the onions and
        garlic.<br></br>
        Place a large frying pan on a medium heat and pour in the oil.<br></br>
        Sauté the onions, garlic, cumin, and a good pinch of salt and pepper for
        20 minutes until deep golden brown. <br></br>
        Make sure to stir occasionally.<br></br>
        <br></br>
        Meanwhile, pick the pomegranate seeds. <br></br>
        Pick and roughly chop the flat leaf parsley, and toss them with the
        toasted flaked almonds, sour cherries, and pomegranate seeds.<br></br>
        Squeeze over th juice from the lemon half, and toss it all together.
        <br></br>
        When the onions are ready, stir through the cooked lentils, check the
        seasoning, and plate up. <br></br>
        Garnish with the dressed fruits and nuts and serve.<br></br>
      </Typography>
    </Card>
  );
}
